import { string } from "yup";
import EN from "./locales/en";
import VI from "./locales/vn";
import i18next from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";

export interface ILang {
  FilterDate: {
    Default: string;
    Daily: string;
    Weekly: string;
    Monthly: string;
    ViewBy: string;
    ErrorSelectDateMessage: string;
  };
  Lang: {
    Code: string;
    TextEN: string;
    TextVN: string;
  };
  Login: {
    ErrorEmail: string;
    LoginDescription: string;
    ButtonText: string;
  };
  Sidebar: {
    Overview: string;
    Manage: string;
    Account: string;
    Dashboard: string;
    ManageUser: string;
    ManageCashflow: string;
    RecordingBalance: string;
    AccountName: string;
    BankAccount: string;
    ManageExchangeRate: string;
    Transaction: string;
    Setting: string;
    Notification: string;
    FAQ: string;
    Cashflow: string;
    ManageAdminUser: string;
    ManagePartnerUser: string;
    Statistics: string;
    AdminStatistics: string;
  };
  Modal: {
    CancelText: string;
    SubmitText: string;
  };
  Setting: {
    AccountInformation: string;
    TimeRegister: string;
    ModalTitle: string;
    ModalOldPassword: string;
    ModalPassword: string;
    ModalOldPasswordPlaceholder: string;
    ModalPasswordPlaceholder: string;
    ModalConfirmPassword: string;
    UpdatePasswordSuccess: string;
    UpdateFail: string;
  };
  Role: {
    Owner: string;
    Admin: string;
    ViewReport: string;
  };
  Common: {
    UpdateSuccess: string;
    InsertNew: string;
    Edit: string;
    Update: string;
    Delete: string;
    Status: string;
    DateCreated: string;
    RowPerPage: string;
    Of: string;
    More: string;
    Code: string;
    Name: string;
    NameValidate: string;
    Description: string;
    Title: string;
    Content: string;
    Price: string;
    DiscountPrice: string;
    Type: string;
    Prominent: string;
    StartDate: string;
    EndDate: string;
    Quantity: string;
    Product: string;
    Customer: string;
    Detail: string;
    Cancel: string;
    Confirm: string;
    Inflow: string;
    Outflow: string;
    Active: string;
    Deactive: string;
    BankNumber: string;
    Currency: string;
    ApiError: string;
    Amount: string;
    AmountPlaceholder: string;
    Search: string;
    Role: string;
    Date: string;
    FirstName: string;
    LastName: string;
    Password: string;
    Logout: string;
    PasswordValidate: string;
    PasswordOldValidate: string;
    PasswordConfirmValidate: string;
    ResetPassword: string;
    UpdateCashflow: string;
    AddMore: string;
    TimeDefault: string;
    AllAccountBank: string;
    CompanyName: string;
    PhoneNumber: string;
    EnterPhoneNumber: string;
    QuantityMember: string;
    Limit: string;
    PercentComplete: string;
    Close: string;
    Color: string;
    ExpectedTime: string;
    Hour: string;
    Minute: string;
    Processing: string;
    SearchTasks: string;
    SearchTaskAssignees: string;
    SearchByTime: string;
    All: string;
    CreatedBy: string;
    At: string;
    LastUpdated: string;
    NotSet: string;
    TotalTime: string;
    Used: string;
    UnexpectedError: string;
    NoDescription: string;
    CollapseDescription: string;
    ExpandDescription: string;
    UploadFile: string;
    TaskList: string;
    LoadMore: string;
    EnterContent: string;
    Send: string;
    Reply: string;
    NoData: string;
    Creator: string;
    Day: string;
    LoadingMore: string;
    To: string;
    Undefined: string;
    Hello: string;
    LoadingDataPleaseWait: string;
    UserGuide: string;
    ClearSearch: string; // nút "Xoá tìm kiếm"
    SearchFoundResult: string; // "Tìm thấy {count} kết quả"
    Today: string;
    Month: string;
    Week: string;
    List: string;
    ListDay: string;
    From: string;
  };
  Management: {
    Task: string;
    ContentTask: string;
    Feature: string;
    SomePopularFeatures: string;
    InternalAnnouncements: string;
    ContentInternalAnnouncements: string;
    CompanyRules: string;
    ContentCompanyRules: string;
    MeetingSchedule: string;
    ContentMeetingSchedule: string;
    LeaveManagement: string;
    ContentLeaveManagement: string;
    ContentLinkCoDrive: string;
    ContentGoogleAds: string;
    ContentGoogleConsole: string;
    GoogleToolContent: string;
    CustomerSupport: String;
    ContentCustomerSupport: string;
    Workflow: string;
    AvailableWorkflows: string;
    ClosedWorkflow: string;
    WorkflowCreatedbyMe: string;
    WorkflowManagement: string;
    CreateNewWorkflow: string;
    UpdateWorkflow: string;
    DuplicateWorkflow: string;
    DuplicateNewWorkflow: string;
    NewWorkflowName: string;
    ExportToExcel: string;
    CloseWorkflow: string;
    WorkflowName: string;
    WorkflowCategory: string;
    WorkflowAdministrators: string;
    ContentWorkflowAdministrators: string;
    GroupCreateTask: string;
    ContentGroupCreateTask: string;
    PlacehoderGroupCreateTask: string;
    WorkflowSupervisor: string;
    ContentWorkflowSupervisor: string;
    AutomaticallyForwardTaskWhenReachingThisStage: string;
    WhenReachingTheSelectedStageTheTaskWillAutomaticallyMoveToAnotherWorkflow: string;
    NoStagesAvailable: string;
    SelectWorkflow: string;
    SelectTransitionStage: string;
    OtherOptions: string;
    MemberGroupsWithPermissionToWiewTheWorkflow: string;
    MembersOrMemberGroupsWhoCanSeeTheWorkflowInTheList: string;
    WorkflowUserGuide: string;
    DetailedDescriptionOfTheWorkflow: string;
    DetailedWorkflowDescription: string;
    ReasonForTaskFailure: string;
    PleaseProvideDetailedPossibleReasonsForTaskFailureIfAny: string;
    EnterAPossibleReasonForFailure: string;
    PleaseEnterTheWorkflowName: string;
    PleaseSelectTheWorkflowCategory: string;
    PleaseSelectAWorkflow: string;
    PleaseSelectATransitionStage: string;
    CreateTask: string;
    CreateContract: string;
    CreateWorkflow: string;
    AddStage: string;
    AddNewStage: string;
    EditStage: string;
    StageName: string;
    PleaseEnterTheTaskName: string;
    InvalidTime: string;
    EditTask: string;
    UpdatePersonalDeadlines: string;
    PersonalDeadlines: string;
    EditContract: string;
    TaskName: string;
    ContractName: string;
    AssignTaskTo: string;
    ContractExecutor: string;
    EnterMemberName: string;
    TaskDescription: string;
    ContractDescription: string;
    ShortTaskDescription: string;
    ShortContractDescription: string;
    Follower: string;
    ExpectedCompletionDate: string;
    ClickToSelectADate: string;
    ClickToSelectATime: string;
    Deadline: string;
    Expectation: string;
    NoDeadline: string;
    Attachments: string;
    AttachUpTo10Files: string;
    DragFilesHere: string;
    OrSelectFilesFromYourComputer: string;
    NumberOfFilesExceeded: string;
    MaximumFileUpload: string;
    InvalidFileFormat: string;
    StageAdministrator: string;
    DefaultFollowersOfTheStage: string;
    StageAssignee: string;
    HowIsTheTaskAssignedOrReassigned: string;
    StageCompletionGuide: string;
    StageCompletionInstructions: string;
    RetainPreviousAssignee: string;
    ReturnToFirstAssignee: string;
    UnassignedStageManagerDecides: string;
    DecisionByStageMover: string;
    RandomlyAssign: string;
    ReturnToPreviousStageAssignee: string;
    PleaseEnterTheStageName: string;
    PleaseSelectTheTaskAssignmentMethod: string;
    PleaseSelectAStage: string;
    PleaseEnterTheCorrectFormat: string;
    PleaseEnterTheWorkflowCategoryName: string;
    ConfirmWorkflowClosure: string;
    AreYouSureYouWantToCloseThisWorkflow: string;
    CurrentStage: string;
    TimeSpent: string;
    NextStage: string;
    TaskInformation: string;
    MovedToStageAt: string;
    Stage: string;
    TaskFollower: string;
    EditFollowers: string;
    StageFollower: string;
    WorkflowFollower: string;
    StageProgress: string;
    WaitingStage: string;
    SkippedStage: string;
    Actual: string;
    Duration: string;
    TaskMarkedAsFailed: string;
    TaskMovedToTheNextStage: string;
    TaskTransitionFailed: string;
    EnterTheReasonForFailure: string;
    PleaseEnterTheReasonForFailure: string;
    Transition: string;
    MarkAsFailed: string;
    StageDueDate: string;
    Remaining: string;
    NoTasksYet: string;
    Done: string;
    Fail: string;
    Cancel: string;
    TableView: string;
    GridView: string;
    AddAStageToTheLeft: string;
    AddAStageToTheRight: string;
    DeleteStage: string;
    ConfirmTaskDeletion: string;
    ConfirmDeletionOfThisTask: string;
    ConfirmStageDeletion: string;
    AreYouSureYouWantToDeleteThisStage: string;
    OpenInANewTab: string;
    BackToPreviouStage: string;
    ReassignToSomeoneElse: string;
    DeleteTask: string;
    SelectTaskAssignees: string;
    PleaseSelectTaskAssignees: string;
    EditDescription: string;
    InProgress: string;
    Assign: string;
    NotAssigned: string;
    TaskAssignedToWhichStage: string;
    ImmutableDeadline: string;
    InsertAt: string;
    InsertBeforeDoneStage: string;
    AdvancedOptions: string;
    AllowExecutorToUpdateNextStageDuration: string;
    SkipSunday: string;
    RequireFinishPreviousTasks: string;
    NotRequired: string;
    Required: string;
    AllowMembersOrFollowersToAddTasksInThisStage: string;
    Price: string;
    Deposit: string;
    WorkflowIconName: string;
    WorkflowIconDescription: string;
    WorkflowIconPlaceholder: string;
  };
  Comment: {
    Comment: string;
    EditComment: string;
  };
  Chat: {
    GroupNew: string;
    SearchForChatGroup: string;
    NewChat: string;
    Messages: string;
    ConversationName: string;
    CreateGroup: string;
    NoMessagesYet: string;
    SeenAt: string;
    TypeYourMessage: string;
    PleaseEnterTheGroupName: string;
    EditConversationName: string;
  };
  Summary: {
    Title: string;
    Loading: string;
    Activity: string;
    Notifications: string;
    NotificationsLoading: string;
    NotificationsNoMore: string;
    Traffic: string;
    CompletionRate: string;
    TaskCount: string;
    SearchPlaceholder: string;
    NoWorkflow: string;
    Cards: {
      TotalTasks: string;
      CompletedTasks: string;
      FailedTasks: string;
      InProgressTasks: string;
      CancelledTasks: string;
    };
    Sort: {
      Default: string;
      TotalDesc: string;
      TotalAsc: string;
      InProgressDesc: string;
      InProgressAsc: string;
      FailedDesc: string;
      FailedAsc: string;
      CompletedDesc: string;
      CompletedAsc: string;
    };
    Table: {
      Performer: string;
      InProgress: string;
      Failed: string;
      Completed: string;
      Cancelled: string;
    };
  };
  User: {
    DoYouWantToChangeYourProfilePicture: string;
    PleaseEnterYourNewPassword: string;
    PleaseEnterYourCurrentPassword: string;
    ConfirmUpdate: string;
    ChangeIt: string;
    AccountManagement: string;
    AccountInformation: string;
    NoEmployeeIDYet: string;
    ChangePassword: string;
    Position: string;
    DirectManager: string;
    NoManagerAssigned: string;
    PersonalContactInformation: string;
    EditAccountInformation: string;
    NoInformationAvailable: string;
    RemainingLeaveDays: string;
    Department: string;
    DirectReports: string;
    Address: string;
    EnterAddress: string;
    EditInformation: string;
    EditDirectManager: string;
    AdminPermissions: string;
    UpdateAnnuaLeave: string;

    AccountManagementMemberTitle: string;
    SearchMembersPlaceholder: string;
    AddAccount: string;
    CreateNewAccountTitle: string;

    LastAndMiddleNameLabel: string;
    EnterLastAndMiddleName: string;
    FirstNameLabel: string;
    EnterFirstName: string;
    UsernameLabel: string;
    EnterUsername: string;
    EmailLabel: string;
    EnterEmailAddress: string;

    AccountType: string;
    PleaseSelect: string;
    PleaseSelectAccountType: string;
    TypeToSearch: string;
    EmployeeLabel: string;

    PleaseEnterLastAndMiddleName: string;
    PleaseEnterFirstName: string;
    PleaseEnterUsername: string;
    InvalidEmailFormat: string;
    PleaseEnterEmailAddress: string;

    CreateAccountSuccess: string;
  };
  Department: {
    AccountManagementGroupTitle: string;

    SearchGroupsPlaceholder: string;

    CreateUserGroupButton: string;
    CreateUserGroupModalTitle: string;

    GroupNameLabel: string;
    EnterGroupName: string;

    UsernameLabel: string;
    EnterGroupUsername: string;

    GroupAdminLabel: string;
    MembersLabel: string;
    MembersNoteCanBeAddedLater: string;

    TypeToSearchPlaceholder: string;
    AddMembersPlaceholder: string;

    SearchNoResultTitleDepartment: string;

    EmptyList: string;

    AdminLabelUppercase: string;
    NoAdminYet: string;

    MembersSuffix: string;
    NoMembersYet: string;

    LoadMore: string;

    PleaseEnterGroupName: string;
    PleaseEnterUsername: string;
    PleaseSelectGroupAdmin: string;

    // ====== ⬇️ Các key MỚI dùng cho màn hình chi tiết công ty ======
    CompanyNameLabel: string;
    CompanyNamePlaceholder: string;

    TaxIdentificationNumberLabel: string;
    TaxIdentificationNumberPlaceholder: string;

    NumberOfUsersCreatedLabel: string;
    NumberOfUsersCreatedPlaceholder: string;

    ExpirationDateLabel: string;
    ExpirationDatePlaceholder: string;

    ConnectionStringLabel: string;
    ConnectionStringPlaceholder: string;

    EditCompanyInfoModalTitle: string;
    AddMembersModalTitle: string;

    DeleteMembersButton: string;
    DeleteCompanyButton: string;

    ConfirmDeleteCompanyTitle: string;
    ConfirmDeleteCompanyContent: string;
    DeleteCompanySuccessMessage: string;

    PleaseEnterCompanyName: string;
    PleaseEnterConnectionString: string;
    PleaseEnterPhoneNumber: string;
    PleaseEnterTaxIdentificationNumber: string;
    PleaseEnterAddress: string;
    PleaseEnterNumberOfUsersCreated: string;
    PleaseEnterEmail: string;
    InvalidEmailFormat: string;
    PleaseSelectMembers: string;

    EditGroupInfoModalTitle: string;

    AddMembersButton: string;
    DeleteGroupButton: string;

    ConfirmDeleteDepartmentTitle: string;
    ConfirmDeleteDepartmentContent: string;
    DeleteDepartmentSuccessMessage: string;

    NoGroupAdminYet: string;
    EditLabel: string;
    SearchNewGroupAdminPlaceholder: string;
    AddMultipleMembersInfo: string;
  };

  UserDetail: {
    // Toast & confirm
    ToastUpdateSuccess: string;
    ToastErrorDefault: string;
    ToastDeactivateSuccess: string;

    ConfirmDeactivateTitle: string;
    ConfirmDeactivateContent: string;
    ConfirmDeactivateSubmitText: string;

    // Buttons
    DeactivateAccountButton: string;
    ModalSubmitText: string;
    ModalCancelText: string;

    // Checkboxes / flags
    TimeOffCheckboxLabel: string;

    // Basic info
    EmployeeCodeLabel: string;
    EmployeeCodePlaceholder: string;

    UsernameLabel: string;
    UsernamePlaceholder: string;

    LastNameLabel: string;
    LastNamePlaceholder: string;

    FirstNameLabel: string;
    FirstNamePlaceholder: string;

    PositionLabel: string;
    PositionPlaceholder: string;

    DepartmentLabel: string;
    DepartmentPlaceholder: string;

    PhoneNumberLabel: string;
    PhoneNumberPlaceholder: string;

    BirthDateLabel: string;

    AddressLabel: string;
    AddressPlaceholder: string;

    // Change password
    NewPasswordLabel: string;
    NewPasswordPlaceholder: string;

    // Change manager
    SelectDirectManagerTitle: string;
    CurrentManagerLabel: string;
    NewManagerLabel: string;
    SearchManagerPlaceholder: string;

    // Roles & permissions
    RoleSelectLabel: string;
    RoleSelectPlaceholder: string;

    PermissionSectionTitle: string;
    PermissionSelectAllLabel: string;

    // Time off
    AnnualLeaveLabel: string;
    AnnualLeavePlaceholder: string;

    // Validation messages
    PleaseEnterLastName: string;
    PleaseEnterFirstName: string;
    PleaseEnterUsername: string;
    PleaseEnterNewPassword: string;
    PleaseSelectManager: string;

    // ⬇️ NEW keys for UserInformationBox
    EmployeeInfoTitle: string;
    EmailLabel: string;
    NoInfo: string;
    DirectManagerLabel: string;
    NoManagerYet: string;
    EmptyList: string; // "Danh sách trống"
    SelectedCount: string; // "Chọn {{count}}" (dùng interpolation)
    FullNameHeader: string; // "HỌ VÀ TÊN"
    AccountHeader: string; // "TÀI KHOẢN"
    InfoHeader: string; // "THÔNG TIN"
    DeleteButtonText: string; // "Xoá"
    NoAnnualLeaveLabel: string; // "Không có"
    DaySuffix: string; // "ngày"
    ConfirmRemoveFromGroupTitle: string; // "Bạn có muốn xoá?"
    ConfirmRemoveFromGroupContent: string; // "Bạn có chắc chắn muốn xoá thành viên khỏi nhóm?"
  };
  TimeOff: {
    PageTitle: string;
    RequestListTitle: string;

    CreateRequestButton: string;
    CreateRequestMenuItem: string;
    ExportExcelMenuItem: string;

    TabMyTimeOff: string;
    TabPending: string;
    TabManagerApproved: string;
    TabCEOApproved: string;
    TabRejected: string;
    TableHeaderIndex: string;
    TableHeaderTitle: string;
    TableHeaderCreator: string;
    TableHeaderDate: string;
    TableHeaderStatus: string;

    ToolbarSelectedCount: string; // dùng với {count}
    ToolbarApproveAll: string;

    EmptyText: string;
    CreateModalTitle: string;
    CreateModalSubmit: string;
    CreateModalCancel: string;
    CreateModalPastDateWarning: string;

    CreateModalTitleLabel: string;
    CreateModalTitleHintPrefix: string;
    CreateModalTitleHintSample: string;
    CreateModalTitlePlaceholder: string;

    CreateModalTypeLabel: string;

    CreateModalDescriptionLabel: string;
    CreateModalDescriptionPlaceholder: string;

    CreateModalSessionLabel: string;
    CreateModalSelectDatePlaceholder: string;

    CreateModalAddNextDay: string;

    CreateModalSuccessMessage: string;

    TypeAnnualLeaveLess3Days: string;
    TypeAnnualLeaveMore3Days: string;
    TypeUnpaidLeaveLess3Days: string;
    TypeUnpaidLeaveMore3Days: string;
    Validation: {
      TitleRequired: string;
      TypeRequired: string;
      DescriptionRequired: string;
      InvalidTime: string;
      TimeRequired: string;
      TimeOffTypeRequired: string;
    };
  };
  Meeting: {
    MeetingManagement: string;
    CreateButton: string; // "Đăng ký lịch họp"
    CreateModalTitle: string; // "Đăng ký lịch họp mới"
    CreateModalSubmit: string; // "Đăng ký"
    CreateModalCancel: string; // "Huỷ bỏ"

    TitleLabel: string; // "Tiêu đề"
    TitlePlaceholder: string; // "Tiêu đề"
    DescriptionLabel: string; // "Mô tả"
    DescriptionPlaceholder: string; // "Mô tả"

    RoomLabel: string; // "Phòng họp"
    RoomPlaceholder: string; // "Vui lòng chọn"
    RoomErrorText: string; // "Vui lòng chọn phòng họp"

    StartTimeLabel: string; // "Thời gian bắt đầu"
    EnterStartTimeLabel: string;
    EndTimeLabel: string; // "Thời gian kết thúc"
    EnterEndTimeLabel: string;
    ParticipantsLabel: string; // "Tham dự"
    ParticipantsPlaceholder: string; // "Gõ tên để chọn người tham dự, ..."
    OtherParticipantsLabel: string; // "Thành phần tham dự khác"
    OtherParticipantsInfo: string; // "Người tham dự khác ngoài công ty"
    OtherParticipantsPlaceholder: string; // "Khách hàng, ..."

    FilterSectionTitle: string; // "Phân loại"
    MyBookingsTitle: string; // "Đăng ký của tôi"

    ToastCreateSuccess: string; // "Đăng ký lịch thành công"

    ValidationTitleRequired: string; // "Vui lòng nhập tiêu đề"
    ValidationDescriptionRequired: string; // "Vui lòng nhập mô tả"
    ValidationRoomRequired: string; // "Vui lòng chọn phòng họp"
    ValidationParticipantsRequired: string; // "Vui lòng chọn người tham dự"
    EventDetail: {
      TooltipDeleteSchedule: string;
      TooltipEditSchedule: string;

      ModalEditTitle: string;
      ModalSubmit: string;
      ModalClose: string;

      FieldStatus: string;
      FieldDateTime: string;
      FieldLocation: string;
      FieldHost: string;
      FieldParticipants: string;
      FieldOtherParticipants: string;

      PlaceholderCancelReason: string;

      Form: {
        Title: string;
        TitlePlaceholder: string;
        Description: string;
        DescriptionPlaceholder: string;
        Room: string;
        RoomPlaceholder: string;
        RoomRequiredMessage: string;
        StartTime: string;
        EndTime: string;
        Participants: string;
        ParticipantsPlaceholder: string;
        OtherParticipants: string;
        OtherParticipantsInfo: string;
        OtherParticipantsPlaceholder: string;
      };

      Validation: {
        TitleRequired: string;
        DescriptionRequired: string;
        StartDateRequired: string;
        ParticipantsRequired: string;
      };

      Actions: {
        Approve: string;
        Reject: string;
        Complete: string;
        CancelRegister: string;
        Cancel: string;
        ConfirmCancel: string;
        Confirm: string;
      };

      Confirm: {
        ApproveTitle: string;
        ApproveContent: string;
        RejectTitle: string;
        RejectContentLine1: string;
        RejectContentLine2: string;
        CompleteTitle: string;
        CompleteContent: string;
        RequestCancelTitle: string;
        RequestCancelContent: string;
        ApproveCancelTitle: string;
        ApproveCancelContent: string;
        DeleteTitle: string;
        DeleteContent: string;
        SubmitText: string;
      };

      Messages: {
        UpdateSuccess: string;
        UpdateError: string;
        DeleteSuccess: string;
        GenericError: string;
      };
    };
  };
  MeetingStatus: {
    Pending: string;
    Confirmed: string;
    Cancel: string;
    WaitCancel: string;
    Completed: string;
    Unknown: string;
  };
  TimeOffStatus: {
    ManagerApprove: string;
    CEOApprove: string;
    Pending: string;
    NotApprove: string;
    Cancelled: string;
    TeamLeaderApprove: string;
  };
  TimeOffDetail: {
    StatusLabel: string;
    StatusUpdateSuccess: string;
    StatusUpdateErrorDefault: string;

    DeleteSuccess: string;
    DeleteErrorDefault: string;

    ApproveButton: string;
    RejectButton: string;
    DeleteButton: string;

    MainInfoSectionTitle: string;
    MainInfoIdPrefix: string;

    CreatedByLabel: string;
    SalaryAffectLabel: string;
    SalaryAffectYes: string;
    SalaryAffectNo: string;
    ContentLabel: string;

    TimeOffSectionTitle: string;
  };
  Docs: {
    SearchPlaceholder: string;
    Unread: string;
    LoadMore: string;
    EmptyTitle: string;
    DocumentType: {
      Title: string;
      AddNew: string;
      ActionActivate: string;
      ActionEdit: string;
      ActionDelete: string;
      ConfirmDeleteTitle: string;
      ConfirmDeleteContent: string;
      ConfirmToggleTitle: string;
      ConfirmToggleContent: string;
      ConfirmButton: string;
      ErrorCommon: string;
      SuccessUpdate: string;
      DeactivatePrefix: string;
    };
    DocumentForm: {
      Document: string;
      TitleCreate: string;
      TitleEdit: string;
      LabelNumberIdentifier: string;
      PlaceholderNumberIdentifier: string;
      LabelTitle: string;
      PlaceholderTitle: string;
      LabelIssueDate: string;
      LabelExpireDate: string;
      LabelContent: string;
      PlaceholderContent: string;
      ErrorTitleRequired: string;
      ErrorContentRequired: string;
      ErrorIssueDateRequired: string;
      LabelReceiver: string;
      PlaceholderReceiver: string;
      LabelSendAllCompany: string;
      LabelDocumentType: string;
      PlaceholderSelect: string;
      ErrorDocumentTypeRequired: string;
      LabelStatus: string;
      PlaceholderSelectStatus: string;
      LabelTags: string;
      PlaceholderTags: string;
      AttachmentTitle: string;
      AttachmentInfo: string;
      AttachmentTooltipDelete: string;
      AttachmentSelectButton: string;
      DeleteFilesSuccess: string;
      DeleteFilesError: string;
      ButtonCancel: string;
      ButtonUpdate: string;
      ButtonCreate: string;
    };
    DocumentTypeForm: {
      TitleEdit: string;
      TitleCreate: string;
      LabelName: string;
      PlaceholderName: string;
      LabelActive: string;
      Processing: string;
      ButtonCancel: string;
      ButtonUpdate: string;
      ButtonCreate: string;
    };
    Admin: {
      ButtonDocumentType: string;
      ButtonCreateDocument: string;
      TableHeaderDocument: string;
      TableHeaderStatus: string;
      TableHeaderType: string;
      TableHeaderTime: string;
      LabelIssueDate: string;
      LabelExpireDate: string;
      NoInfo: string;
      TooltipEdit: string;
      TooltipViewDetail: string;
      TooltipDelete: string;
      ConfirmDeleteTitle: string;
      ConfirmDeleteContent: string;
      ConfirmDeleteSubmit: string;
      UploadError: string;
      EmptyTitle: string;
      ErrorNoDocTypeNoPermission: string;
      LoadingData: string;
      UpdateSuccess: string;
      CreateSuccess: string;
      CommonError: string;
    };
    Status: {
      PendingRelease: string;
      Released: string;
      Revocation: string;
      Unknown: string;
    };
    DownloadFileTooltip: string;
    IssueDate: string;
    ExpirationDate: string;
    NoExpirationInfo: string;
    AttachmentsTitle: string;
  };
  Rules: {
    Title: string;
    Buttons: {
      EditRules: string;
      CancelChanges: string;
      UpdateRules: string;
    };
    Placeholder: {
      EnterRules: string;
    };
    Empty: {
      NoRules: string;
      NoData: string;
    };
    Messages: {
      UpdateSuccess: string;
      UpdateError: string;
    };
  };
  TimeOffType: {
    Title: string;
    Tabs: {
      Types: string;
      MailCC: string;
    };
    Loading: {
      Data: string;
    };
    Table: {
      Columns: {
        Name: string;
        Calculation: string;
        Actions: string;
      };
      Operation: {
        Minus: string;
        NotOperation: string;
      };
    };
    Buttons: {
      CreateType: string;
      Delete: string;
      Edit: string;
      AddMail: string;
    };
    MailCC: {
      DefaultLabel: string;
      EmptyList: string;
    };
    Modal: {
      TitleEdit: string;
      TitleCreate: string;
      Submit: string;
      Close: string;
      Fields: {
        NameLabel: string;
        NamePlaceholder: string;
        OperationLabel: string;
        OperationYes: string;
        OperationNo: string;
      };
      Validation: {
        NameRequired: string;
        OperationRequired: string;
      };
    };
  };
  MeetingRoom: {
    Approve: {
      Sidebar: {
        Title: string;
        TooltipDeleteRoom: string;
        ButtonCreateRoom: string;
      };
      TodaySchedule: {
        Title: string;
      };
      Tabs: {
        Pending: string;
        WaitCancel: string;
        Confirmed: string;
        Completed: string;
      };
      List: {
        MonthTitle: string; // Tháng {{month}}
        NoRoomInformation: string; // fallback khi không có tên phòng
        NoRegistrantData: string; // Không có dữ liệu
      };
      CreateRoomModal: {
        Title: string;
        Submit: string;
        Fields: {
          NameLabel: string;
          NamePlaceholder: string;
          DescriptionLabel: string;
          DescriptionPlaceholder: string;
          LocationLabel: string;
          LocationPlaceholder: string;
        };
        Validation: {
          NameRequired: string;
          LocationRequired: string;
          DescriptionRequired: string;
        };
      };
      Messages: {
        CreateSuccess: string;
        RoomDeleted: string;
        RegisterDeleted: string;
        UpdateSuccess: string;
        GenericError: string;
      };
      Confirm: {
        DeleteRoomTitle: string;
        DeleteRoomContent: string;
        DeleteRoomSubmit: string;

        RejectTitle: string;
        RejectContentLine1: string;
        RejectContentLine2: string;
        RejectSubmit: string;

        ApproveTitle: string;
        ApproveContent: string;
        ApproveSubmit: string;

        CancelRequestTitle: string;
        CancelRequestContent: string;
        CancelRequestSubmit: string;

        CompleteTitle: string;
        CompleteContent: string;
        CompleteSubmit: string;
      };
      Buttons: {
        Reject: string;
        Approve: string;
        ConfirmCancel: string;
        Complete: string;
      };
    };
  };
  Header: {
    Profile: {
      Account: string;
      Support: string;
    };
    Logout: {
      ConfirmTitle: string;
      ConfirmContent: string;
      Button: string;
    };
    Notifications: {
      Title: string; // "Thông báo ({{count}})"
      ReadAllTooltip: string;
      ReadAllConfirmTitle: string;
      ReadAllConfirmContent: string;
      Empty: string;
      LoadMore: string;
    };
  };
  Account: {
    Nav: {
      Personal: string;
      Member: string;
      Group: string;
      Company: string;
      Home: string;
    };
  };
  Gads: {
    Button: {
      Update: string;
    };

    Modal: {
      Title: string;
    };

    Field: {
      GoogleAds: string;
    };

    Validate: {
      IframeRequired: string;
    };
  };
  Gcsl: {
    Button: {
      Update: string;
    };
    Modal: {
      Title: string;
    };
    Field: {
      GoogleAds: string;
    };
    Validate: {
      IframeRequired: string;
    };
  };
  Booking: {
    Calendar: {
      NoEventsText: string;
    };
    MobileList: {
      Today: string; // "Hôm nay"
      Meeting: string; // "lịch họp"
    };
    Validation: {
      RoomNameRequired: string;
      LocationRequired: string;
      DescriptionRequired: string;
    };
    Messages: {
      ConfirmChangeTitle: string;
      ConfirmStart: string;
      ConfirmEnd: string;
      ConfirmButtonText: string;
      UpdateSuccess: string;
      UpdateError: string;
    };
  };
  TaskUpdateModal: {
    UpdateTaskSuccess: string;
    ModalTitle: string;
    ButtonUpdate: string;
    ButtonCancel: string;
    LabelTaskName: string;
    PlaceholderTaskName: string;
    LabelAssignTo: string;
    PlaceholderAssignTo: string;
    LabelDescription: string;
    InfoDescription: string;
    PlaceholderDescription: string;
    LabelComment: string;
    PlaceholderComment: string;
    LabelAttachments: string;
    InfoAttachments: string;
    TitleAttachments: string;
    ValidateTaskName: string;
    ValidateAssign: string;
    EditTitleAttachments: string;
  };
  TimeOffMailCC: {
    ModalTitle: string;
    SubmitText: string;
    CancelText: string;
    LabelCC: string;
    InfoMax: string;
    PlaceholderEmail: string;
    AddMailButton: string;
    ErrorAtLeastOneCC: string;
    DefaultSuccessMessage: string;
  };
  DeleteTimeOffType: {
    ModalTitle: string;
    SubmitText: string;
    CancelText: string;
    ConfirmDeleteLabel: string;
    SuccessMessage: string;
  };
  Payroll: {
    Title: string;
    FileName: string;
    Email: string;
    Attachments: string;
    SendPayroll: string;
    CreatedDate: string;
    Modal: {
      TitleCreate: string;
      ButtonSend: string;
    };
  };
  OpenAiChat: {
    Greeting: string;
    Placeholder: string;
    Uploading: string;
    UploadSuccess: string;
    UploadError: string;
    NoFiles: string;
    DocsTitle: string;
    DocsDesc: string;
    UploadBtn: string;
    DeleteSuccess: string;
    AskHint: string;
    WaitingResponse: string;
    ErrorResponse: string;
    InvalidFile: string;
  };
}

export enum CountryLanguage {
  "EN" = "EN",
  "VI" = "VI"
}

const locale = localStorage.getItem("language");

i18next.use(initReactI18next).init({
  compatibilityJSON: "v3",
  fallbackLng: [locale ? locale.toUpperCase() : `${CountryLanguage.EN}`],
  debug: false,
  resources: {
    EN: {
      translation: EN
    },
    VI: {
      translation: VI
    }
  }
});

const useLanguage = () => {
  const { t } = useTranslation();
  return t;
};

const changeLanguage = (value: CountryLanguage) => {
  Lang.changeLanguage(value);
  localStorage.setItem("language", value);
};

const useI18n = () => {
  const { i18n } = useTranslation();
  return i18n;
};
export { useLanguage, useI18n, changeLanguage };

const Lang = i18next;

export default Lang;
